export class ItemCombo {
    id: number;
    value: string;
    constructor(item) {
        this.id = item.id;
        this.value = item.value;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/dominio/itemCombo.ts